var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.nota_credito.afip_ticket)?_c('b-button',{attrs:{"variant":"primary"},on:{"click":function($event){$event.stopPropagation();return _vm.print.apply(null, arguments)}}},[_c('i',{staticClass:"icon-print"}),_vm._v(" Factura N° "+_vm._s(_vm.nota_credito.afip_ticket.cbte_numero)+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }